export default "__VITE_ASSET__CXWFvq36__"